<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <div
      v-if="loaded"
      class="flex flex-row flex-wrap"
    >
      <FormListItem
        v-for="form in forms"
        :key="form.uuid"
        :form="form"
      />
    </div>
    <div
      v-if="loaded && !forms.length"
      class="empty mb-4 mx-2"
    >
      <section>
        <h2 v-text="'There are currently no forms available'" />
      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import FormListItem from './FormListItem'

export default {
  name: 'FormList',
  components: {
    FormListItem,
  },
  props: {
    loaded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState({
      count: state => state.form.forms.data.length,
      totalCount: state => _.get(state.form.forms, 'meta.pagination.total', 0),
      forms: state => state.form.forms.data,
    }),
  },
}
</script>
